import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, allowedRole }) {

  const session = JSON.parse(
    sessionStorage.getItem("session")
  );

  const SESSION_LIMIT = 12 * 60 * 60 * 1000;

  if (!session) {
    return <Navigate to="/login" />;
  }

  const now = Date.now();

  if (now - session.loginTime > SESSION_LIMIT) {

    sessionStorage.clear();

    return <Navigate to="/login" />;
  }

  if (allowedRole && session.role !== allowedRole) {
    return <Navigate to="/" />;
  }

  return children;

}